module.exports = __webpack_public_path__ + "static/media/join.3348cc57.webp";